var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-form-group', {
    class: _vm.labelClass,
    attrs: {
      "id": _vm.filterLabelId,
      "label": _vm.labelWithoutColon,
      "label-for": _vm.filterId
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_vm.hasHovertip ? _c('div', [_vm._v("\n           \n          "), _vm.hasHovertip ? _c('img', {
          attrs: {
            "id": _vm.getHovertipId,
            "src": _vm.hovertipSrc,
            "alt": "help"
          }
        }) : _vm._e(), _vm._v(" "), _vm.hasHovertip ? _c('b-popover', {
          attrs: {
            "target": _vm.getHovertipId,
            "triggers": "hover focus"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("\n              " + _vm._s(_vm.getHovertipTitle) + "\n            ")];
            },
            proxy: true
          }], null, false, 2242619117)
        }, [_vm._v("\n            " + _vm._s(_vm.getHovertipText) + "\n          ")]) : _vm._e()], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _vm._v(" "), !_vm.hideEmpty || _vm.getValue.length ? _c('b-form-select', {
    class: _vm.filterClass,
    attrs: {
      "show-labels": false,
      "id": _vm.filterId,
      "disabled": _vm.disable,
      "value-field": _vm.trackBy,
      "text-field": _vm.textField,
      "value": _vm.$store.getters[_vm.storeWatch],
      "options": _vm.getValue,
      "label": _vm.displayValue,
      "multiple": _vm.multiple,
      "required": _vm.elementRequired
    },
    on: {
      "change": _vm.updateFilter
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, [_c('template', {
    slot: "first"
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": _vm.disableEmptySelection
    }
  }, [_vm._v("\n          -- Please select an option --\n        ")])], 1)], 2) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }